import {
  checkAppPermission,
  decodeJwtPayload,
  resolveFokusRoleFromIdToken,
  workspaceRoleToDocsRole,
} from './auth';
import {
  setActiveWorkspaceId,
  getActiveWorkspaceId,
  hydrateWorkspaceIdFromStorage,
} from './workspaceContext';
import { SprintAPI } from './sprintApi';
import { SettingsAPI } from './settingsApi';
import { ViewsAPI } from './viewsApi';
import { SopAPI } from './sopApi';
import { SearchAPI } from './searchApi';
import { WorkspaceAPI } from './workspaceApi';
import { ClockAPI } from './clockApi';
import { BackupAPI } from './backupApi';

export default {
  checkAppPermission,
  decodeJwtPayload,
  resolveFokusRoleFromIdToken,
  workspaceRoleToDocsRole,
  setActiveWorkspaceId,
  getActiveWorkspaceId,
  hydrateWorkspaceIdFromStorage,
  SprintAPI,
  SettingsAPI,
  ViewsAPI,
  SopAPI,
  SearchAPI,
  WorkspaceAPI,
  ClockAPI,
  BackupAPI,
};
